import {
   TherapeuticGroupIssue,
   TherapeuticGroupOccupancy,
   TimeOfDay,
} from '@dreryk/egabinet-group-session-frontend-api';

export const TIMES_OF_DAY: TimeOfDay[] = ['MORNING', 'AFTERNOON', 'EVENING'];
export const DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const;
export const OCCUPANCIES: TherapeuticGroupOccupancy[] = ['FULL', 'HAS_VACANCIES'];
export const ISSUES: TherapeuticGroupIssue[] = ['NO_SCHEDULE', 'NO_PRACTITIONER', 'BELOW_MINIMUM_OCCUPANCY'];
